import MANAGE_USERS from '../actionTypes/manageUser_actionType';

const initialState = {
  query:{
    role:'all'
  }
}

const manageUsers = (state = initialState, action) => {
  switch (action.type) {
    case MANAGE_USERS.UPDATE_QUERIES_FOR_GET_USERS:
      return {
        ...state,
        query: action.payload
      }
    case MANAGE_USERS.RESET_INITIAL_DATA:
      let newQuery = {
        role:'all'
      }
      return {
        ...state,
        query: newQuery
      }
    default:
      return { ...state }
  }
}

export default manageUsers
